export default function openApp(data, nameApp) {
  var filter = data.openApp.filter((fil) => fil === nameApp);
  if (filter.length === 0) {
    data.set().setState({
      openStart: false,
      openSearch: false,
      openNotification: false
    });
    setTimeout(() => {
      data.set().setState({ openApp: [...data.openApp, nameApp] });
    }, 2000);
  }
}
